import useExportCompanyShareholdings from 'hooks/data/company/useExportCompanyShareholdings';
import Action from 'components/Actions/Action';
import { CloudDownload } from '@mui/icons-material';
import { SortOrder } from 'further-types/utils';

type Props = {
  companyId: string;
  tradingName: string;
  onClick?: () => void;
  disabled?: boolean;
};

export const DownloadShareholdingsAction: React.FC<Props> = ({
  companyId,
  tradingName,
  onClick,
  disabled,
}) => {
  const { exportCompanyShareholdings, isExportingCompanyShareholdings } =
    useExportCompanyShareholdings({
      companyId,
      tradingName,
      orderBy: 'investor.fullName',
      order: SortOrder.Asc,
    });

  const handleExport = async () => {
    await exportCompanyShareholdings({
      tradingName,
    });
    onClick?.();
  };

  return (
    <Action
      label="Download shareholdings"
      icon={CloudDownload}
      color="primary"
      disabled={disabled || isExportingCompanyShareholdings}
      onClick={handleExport}
    />
  );
};
